<template>
	<section>
		<div class="header">
            <div class="logo">
                <img src="../assets/images/logo.png"/>
            </div>
            <div class="datetime">{{dateTime}}</div>
            <div class="header_right">
                <div class="index_icon" @click="goIndex">
                    <img src="../assets/images/icon_index.png" alt=""/>
                </div>
                <div class="index_text" @click="goIndex">首页</div>
                <div class="my_icon">
                    <img src="../assets/images/icon_my.png" alt=""/>
                </div>
                <div class="my_text">您好！{{userInfo?(userInfo.phone?userInfo.phone:'--'):'--'}}</div>
                <div class="logout_text" @click="logoutFun">退出</div>
                <div class="logout_icon" @click="logoutFun">
                    <img src="../assets/images/icon_logout.png" alt=""/>
                </div>
            </div>
        </div>
	</section>
</template>
<script>
	export default {
		data() {
			return {
                dateTime: '',
                userInfo: {}
			}
        },
		mounted() {
            let that = this;
            this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			setInterval(function(){
                let date = new Date();
                var y = date.getFullYear();  
                var m = date.getMonth() + 1;  
                m = m < 10 ? ('0' + m) : m;  
                var d = date.getDate();  
                d = d < 10 ? ('0' + d) : d;  
                var h = date.getHours();  
                var minute = date.getMinutes();  
                var seconds = date.getSeconds();
                h = h < 10 ? ('0' + h) : h;
                minute = minute < 10 ? ('0' + minute) : minute; 
                seconds = seconds < 10 ? ('0' + seconds) : seconds; 
                that.dateTime = y + '年' + m + '月' + d+'日'+h+':'+minute+':'+seconds;
            },1000)
		},
		methods: {
            goIndex(){
                this.$router.push({ path: "/home" });
            },
			logoutFun(){
                let that = this;
                this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					localStorage.clear();
					that.$router.push('/');
				}).catch(() => {

				});
            }
		}
	}

</script>

<style>
.header{
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.logo{
    width: 488px;
    height: 83px;
    margin-right: 122px;
}
.datetime{
    width: 212px;
    height: 38px;
    background-color: #a63637;
    line-height: 38px;
    font-size: 14px;
    color: #f0ffed;
}
.header_right{
    width: 478px;
    height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
}
.header_right .index_icon{
    width: 18px;
    height: 18px;
    padding-right: 6px;
    cursor: pointer;
}
.header_right .index_text{
    width: 32px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #f6ffff;
    margin-right: 24px;
    cursor: pointer;
}
.header_right .my_icon{
    width: 18px;
    height: 18px;
    padding-right: 6px;
}
.header_right .my_text{
    width: auto;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #f6ffff;
    margin-right: 24px;
}
.header_right .logout_icon{
    width: 18px;
    height: 18px;
    padding-right: 6px;
    cursor: pointer;
}
.header_right .logout_text{
    width: 32px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #f6ffff;
    cursor: pointer;
    padding-right: 6px;
}

</style>